var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoHelp = function SvgInfoHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "4 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.333a8.333 8.333 0 1 1 0-16.666 8.333 8.333 0 0 1 0 16.666Zm0-1.666a6.667 6.667 0 1 0 0-13.335 6.667 6.667 0 0 0 0 13.334Zm-.833-4.167h1.667v1.666h-1.667V14.5Zm1.667-1.371v.537h-1.667v-1.25a.833.833 0 0 1 .833-.833 1.25 1.25 0 1 0-1.226-1.495L9.14 9.761a2.918 2.918 0 1 1 3.695 3.368Z",
    fill: "#69B6AA"
  })));
};
export default SvgInfoHelp;